export default __webpack_public_path__ + "static/svetlana-89fbf029272288b5f391ce8ad1b609c1.jpeg";